import {Div, Label} from 'components';
import {Ecolors} from 'constant';
import React from 'react';
import {useAppSelector} from 'store/hooks';
import {convertNumber, parseMultilanguage} from 'utils';

function ComBubble(props: {isContent4?: boolean}) {
  const walletBounty = useAppSelector(state => state.asset.walletBounty);
  const {eventBounty} = walletBounty;
  const I18nState = useAppSelector(state => state.languages.I18nState);
  return (
    <Div flexDirection="row" paddingBottom={5} paddingRight={5}>
      <Div flexDirection="column" alignItems="flex-start">
        <Div
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start">
          <Label size={14}>{`eventreward.content1`}</Label>
          <Div
            paddingHorizontal={3}
            backgroundColor={Ecolors.eventYellow}
            borderRadius={20}>
            <Label color={Ecolors.whiteColor} multilanguage={false} size={14}>
              {`100 ${parseMultilanguage(`eventreward.diemthuong`)} `}
            </Label>
          </Div>
        </Div>
        <Div
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start">
          <Label size={11} multilanguage={false}>{`(${parseMultilanguage(
            `eventreward.tuongduong`,
          )}`}</Label>
          {eventBounty && (
            <Label multilanguage={false} size={11}>
              {` ${convertNumber(eventBounty, true)} VND)`}
            </Label>
          )}
        </Div>
        <Label size={14} style={{width: '50%'}}>{`eventreward.content2`}</Label>
        <Label style={{width: '50%'}} multilanguage={false} size={11}>
          {parseMultilanguage(`eventreward.content3`)}
          {props.isContent4 && parseMultilanguage(`eventreward.content4`)}
        </Label>
      </Div>
    </Div>
  );
}

export default React.memo(ComBubble);
